export interface Address {
  line1?: string;
  line2?: string;
  city?: string;
  province?: string;
  postalCode?: string;
  country?: string;
}

export function AddressFields({ value, onChange, legend }: { value: Address; onChange: (a: Address) => void; legend: string }) {
  const set = (k: keyof Address, v: string) => onChange({ ...value, [k]: v });
  return (
    <fieldset style={{ border: '1px solid var(--border)', borderRadius: 6, padding: '0.75rem', marginBottom: '1rem' }}>
      <legend style={{ fontSize: '0.8rem', fontWeight: 600, padding: '0 0.4rem' }}>{legend}</legend>
      <div className="field">
        <label>Address line 1</label>
        <input value={value.line1 ?? ''} onChange={(e) => set('line1', e.target.value)} />
      </div>
      <div className="field">
        <label>Address line 2</label>
        <input value={value.line2 ?? ''} onChange={(e) => set('line2', e.target.value)} />
      </div>
      <div className="row cols-2">
        <div className="field">
          <label>City</label>
          <input value={value.city ?? ''} onChange={(e) => set('city', e.target.value)} />
        </div>
        <div className="field">
          <label>Province / State</label>
          <input value={value.province ?? ''} onChange={(e) => set('province', e.target.value)} />
        </div>
      </div>
      <div className="row cols-2">
        <div className="field">
          <label>Postal / ZIP</label>
          <input value={value.postalCode ?? ''} onChange={(e) => set('postalCode', e.target.value)} />
        </div>
        <div className="field">
          <label>Country</label>
          <input value={value.country ?? ''} onChange={(e) => set('country', e.target.value)} />
        </div>
      </div>
    </fieldset>
  );
}
